import React, { Component } from "react";
//import Moment from 'react-moment';
import { css } from "aphrodite/no-important";
import { styles } from "./EnergyServicesHomeStyles";
import Header from "../components/Header";
import AssistedLivingNavigation from "../components/AssistedLivingNavigation";
import PageTitle from "../components/PageTitle";
import FeedbackPanel from "../components/FeedbackPanel";
import PopupWrapper from "../components/PopupWrapper";

class AssistedLivingFeedback extends Component {
  render() {
    return (
      <div>
        <Header
          title={"Parent's Home"}
          backTitle={"Dashboard"}
          isAssistedLiving={true}
          backHref={"/"}
        />
        <PageTitle
          title={"Feedback"}
          subTitle={"We care about all of your feedback."}
        />
        <AssistedLivingNavigation {...this.props.location} />
        <div className={css(styles.innerNarrow)}>
          <PopupWrapper />
          <FeedbackPanel {...this.props} user="dependant" />
        </div>
      </div>
    );
  }
}

export default AssistedLivingFeedback;
